import React from "react";
import styles from "./button.module.scss";

export interface ButtonProps {
  children?: any;
  disableBtn?: boolean;
  className?: any;
  template?: "gray" | "blue" | "orange" | "orange_outline" | "blue_outline";
  label: string;
  icon?: string;
  size?: "small" | "small_xs" | "large" | "large_xl";
  onClick?: () => void;
}

export const TEST_ID = "button-testid";

export const Button: React.FC<ButtonProps> = ({
  disableBtn,
  className,
  onClick,
  children,
  label,
  template,
  icon,
  size,
}) => {
  const Icon = React.lazy((): any =>
    import("react-icons/md").then((module) => ({ default: module[icon] }))
  );

  return (
    <button
      data-testid={TEST_ID}
      disabled={disableBtn}
      type="submit"
      className={[
        className,
        styles.btn,
        styles[`btn_${template}`],
        styles[`btn_${size}`],
      ].join(" ")}
      onClick={onClick}
    >
      {icon && (
        <React.Suspense fallback={null}>
          <Icon className={styles.btn__icon} />
        </React.Suspense>
      )}
      <span className={styles.btn__text}>{label}</span>
    </button>
  );
};
